import { connect } from 'react-redux/dist/react-redux';
import DetailSimlation from '../components/DetailSimulation';

function mapStateToProps(state) {
    return {
        langues: state.demandeCredit.getIn(['langues', 'value']), 
    };
  }
export default connect(mapStateToProps)(DetailSimlation);
